import styled from "styled-components";
import { FiGithub, FiLinkedin, FiMail } from "react-icons/fi";
import { IconContext } from "react-icons/lib";

const Container = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  margin-left: 10vh;
`;

const View = styled.div`
  margin-bottom: 15px;
`;

const github = "https://github.com/guilhermeytalo";
const linkedin = "https://www.linkedin.com/in/guilhermeytalo/";
const email = "mailto: contatoguilhermeytalo@outlook.com";
function Contact() {
  return (
    <>
      <IconContext.Provider value={{ color: "#fff", size: "25px" }}>
        <Container>
          <View>
            <a href={github}>
              <FiGithub />
            </a>
          </View>
          <View>
            <a href={linkedin}>
              <FiLinkedin />
            </a>
          </View>
          <View>
            <a href={email}>
              <FiMail />
            </a>
          </View>
        </Container>
      </IconContext.Provider>
    </>
  );
}

export default Contact;
